// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "desktop" + "_" + "5f16b1ca662bd5a8c5e0" + ".css";
};